import { App, Flex, Spin } from 'antd';
import withGuard from 'components/withGuard';
import React, { useEffect, useState } from 'react';
import { Routes, useNavigate, useParams } from 'react-router';
import { Route } from 'react-router-dom';
import { captureException } from 'utils/errors';
import { getCustomerById } from 'api/customers';
import AddressesTab from './AddressesTab';
import Container from './Container';
import CreditHistory from './CreditCardHistory';
import GiftCardHistory from './GiftCardHistory';
import OrdersTab from './OrdersTab';
import Overview from './Overview';
import PromotionsTab from './PromotionsTab';
import ActivityTab from './ActivityTab';
import AdjustBalance from './AdjustBalance';

const ROUTES = [
  {
    label: 'Overview',
    path: '',
    Component: Overview,
    key: 1,
  },
  {
    label: 'Activity',
    path: 'activity',
    Component: ActivityTab,
    key: 7,
  },
  {
    label: 'Orders',
    path: 'orders',
    Component: OrdersTab,
    key: 2,
  },
  {
    label: 'Addresses',
    path: 'addresses',
    Component: AddressesTab,
    key: 5,
  },
  {
    label: 'Promotions',
    path: 'promotions',
    Component: PromotionsTab,
    key: 6,
  },
  {
    label: 'Financials',
    path: 'credit-history',
    Component: CreditHistory,
    key: 3,
  },
  {
    label: 'Gift cards',
    path: 'gift-card',
    Component: GiftCardHistory,
    key: 4,
  },
  {
    path: 'orders/:orderId',
    Component: Overview,
    key: 8,
  },
  {
    path: 'adjust-balance',
    Component: AdjustBalance,
    key: 7,
  },
];

function CustomerDetail() {
  const [customer, setCustomer] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const { message } = App.useApp();

  useEffect(() => {
    const getCustomerData = () => {
      setCustomer(null);
      getCustomerById(id)
        .then((res) => {
          setCustomer(res.data);
        })
        .catch((e) => {
          captureException(e);
          message.error('Contact not found');
          navigate('/console/customers');
        });
    };
    getCustomerData();
  }, [id]);

  if (!customer) {
    return (
      <Flex justify="center" align="center" className="h-[50vh]">
        <Spin size="large" />
      </Flex>
    );
  }

  return (
    <Routes>
      <Route path="" element={<Container />}>
        {ROUTES.map(({ path, Component }) => (
          <Route key={path} path={path} element={<Component customer={customer} setCustomer={setCustomer} />} />
        ))}
      </Route>
    </Routes>
  );
}

export default withGuard(CustomerDetail, null, { redirect: true });
